import { useTranslation } from 'react-i18next';

export default function useLanguage() {
  const { i18n, t } = useTranslation();

  const setLanguage = (lng) => {
    if (!lng) return;
    i18n.changeLanguage(lng);
    // Persist via detector config (localStorage)
    try {
      localStorage.setItem('i18nextLng', lng);
    } catch {}
  };

  return { t, lang: i18n.language, setLanguage };
}


